module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"works_growth_overview":"Works growth overview","absolute_growth":"Absolute growth","relative_growth":"Relative growth","change":"Change"},"cs":{"works_growth_overview":"Přehled růstu děl","absolute_growth":"Absolutní růst","relative_growth":"Relativní růst","change":"Změna"}}')
  delete Component.options._Ctor
}
